export default function useAppearanceColorSet(_ref) {
  var {
    appearance,
    colorScheme
  } = _ref;
  switch (appearance) {
    case 'danger':
    case 'negative':
      return {
        appearance: 'primary',
        colorScheme: 'negative'
      };
    case 'success':
    case 'positive':
      return {
        appearance: 'primary',
        colorScheme: 'positive'
      };
    case 'warning':
      return {
        appearance: 'primary',
        colorScheme: 'warning'
      };
    case 'tertiary':
      return {
        appearance: 'ghost',
        colorScheme: 'primary'
      };
  }
  if (colorScheme === 'default') {
    return {
      appearance,
      colorScheme: 'primary'
    };
  }
  return {
    appearance,
    colorScheme
  };
}